import { Box, Stack, Typography, useTheme } from '@mui/material';
import { isEmpty } from 'lodash';

// Components
import ExpandableBox from 'src/components/common/ExpandableBox';
import FlagCountry from 'src/components/common/FlagCountry';
import TableHorizontal from 'src/components/TableHorizontal';

// Utilities
import { renderTextOrDefault } from 'src/utils/helpers/stringHelpers';
import { useNavigate } from 'react-router-dom';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import { TypeBuyerSupplier } from 'src/utils/constants/enum';
import LinkToCompanyDetail from 'src/components/LinkToCompanyDetail';
import React from 'react';
import { useQueryParams } from 'src/hooks/useQueryParam';

const Buyer = ({ tradeDataDetail }: { tradeDataDetail: IBillOfLadingDetail }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const queryParams = useQueryParams();
  const configColumn = [
    {
      label: 'Buyer',
      isShow: (data: IBillOfLadingDetail) => !isEmpty(data?.buyer_name),
      renderCell: (data: IBillOfLadingDetail) => (
        <LinkToCompanyDetail
          id={data?.buyer?.id}
          companyName={data?.buyer_name || ""}
          params={queryParams}
          viewedAsType={TypeBuyerSupplier.buyer}
        />
      ),
    },
    {
      label: 'Importing Country',
      isShow: (data: IBillOfLadingDetail) => !isEmpty(data?.buyer?.country_code) || !isEmpty(data?.buyer?.country_name),
      renderCell: (data: IBillOfLadingDetail) => (
        <Stack spacing={1} direction="row" alignItems="center">
          <FlagCountry code={data?.buyer?.country_code || ''} />
          <Typography color={'text.secondary'} variant="body2">
            {renderTextOrDefault(data?.buyer?.country_name)}
          </Typography>
        </Stack>
      ),
    },
    {
      label: 'Buyer Address',
      isShow: (data: IBillOfLadingDetail) => !isEmpty(data?.buyer?.jurisdiction),
      renderCell: (data: IBillOfLadingDetail) => (
        <Typography color={'text.secondary'} variant="body2">
          {renderTextOrDefault(data?.buyer?.jurisdiction)}
        </Typography>
      ),
    },
  ];

  return (
    <ExpandableBox title="Buyer" openDefault={true} flex={1}>
      <Box
        padding={3}
        display="flex"
        flexDirection="column"
        bgcolor={theme.palette.background.default}
        borderRadius={`0px 0px ${theme.shape.borderRadius * 2}px ${theme.shape.borderRadius * 2}px`}
      >
        <TableHorizontal colKeyWidth={350} configColumn={configColumn} data={tradeDataDetail} />
      </Box>
    </ExpandableBox>
  );
};

export default Buyer;
